import {
  SEARCHING_ASSET,
  SEARCHING_ASSET_SUCCEDDED,
  SEARCHING_ASSET_FAILED,
  INVALIDATE_ASSET_SEARCH_RESULT,
  SEARCHING_STREAM,
  SEARCHING_STREAM_SUCCEDDED,
  SEARCHING_STREAM_FAILED,
  INVALIDATE_STREAM_SEARCH_RESULT,
  SEARCHING_GROUP,
  SEARCHING_GROUP_SUCCEDDED,
  SEARCHING_GROUP_FAILED,
  INVALIDATE_GROUP_SEARCH_RESULT,
  SEARCHING_COLLECTION,
  SEARCHING_COLLECTION_SUCCEDDED,
  SEARCHING_COLLECTION_FAILED,
  INVALIDATE_COLLECTION_SEARCH_RESULT,
  SEARCHING_CONTACT,
  SEARCHING_CONTACT_SUCCEDDED,
  SEARCHING_CONTACT_FAILED,
  INVALIDATE_CONTACT_SEARCH_RESULT,
  SEARCHING_CONTACT_LIST,
  SEARCHING_CONTACT_LIST_SUCCEDDED,
  SEARCHING_CONTACT_LIST_FAILED,
  INVALIDATE_CONTACT_LIST,
  SEARCHING_CONTACT_FOR_AUTOCOMPLETE,
  SEARCHING_CONTACT_FOR_AUTOCOMPLETE_SUCCEDDED,
  SEARCHING_CONTACT_FOR_AUTOCOMPLETE_FAILED,
  INVALIDATE_AUTOCOMPLETE_CONTACT,
  FETCHING_TAGS,
  FETCHING_TAGS_SUCCEDDED,
  FETCHING_TAGS_FAILED,
  INVALIDATE_TAGS,
  SEARCHING_ASSET_DETAIL,
  SEARCHING_ASSET_DETAIL_SUCCEDDED,
  SEARCHING_ASSET_DETAIL_FAILED,
  INVALIDATE_ASSET_DETAIL_SEARCH_RESULT,
  SEARCHING_USERS_REQUEST,
  SEARCHING_USERS_SUCCEDDED,
  SEARCHING_USERS_FAILED,
  SEARCHING_USER_GROUPS_REQUEST,
  SEARCHING_USER_GROUPS_SUCCEDDED,
  SEARCHING_USER_GROUPS_FAILED,
  INVALIDATE_AUTOCOMPLETE_USER_GROUP,
  SEARCHING_OPPORTUNITY_RECOMMENDED_ASSETS_REQUEST,
  SEARCHING_OPPORTUNITY_RECOMMENDED_ASSETS_SUCCEEDED,
  SEARCHING_OPPORTUNITY_RECOMMENDED_ASSETS_FAILED,
  SEARCHING_OPPORTUNITY_RECOMMENDED_STREAMS_REQUEST,
  SEARCHING_OPPORTUNITY_RECOMMENDED_STREAMS_SUCCEEDED,
  SEARCHING_OPPORTUNITY_RECOMMENDED_STREAMS_FAILED,
  SEARCHING_OPPORTUNITY_SHARED_ASSETS_REQUEST,
  SEARCHING_OPPORTUNITY_SHARED_ASSETS_SUCCEEDED,
  SEARCHING_OPPORTUNITY_SHARED_ASSETS_FAILED,
  SEEK_ANSWER_FOR_QUESTION_REQUEST,
  SEEK_ANSWER_FOR_QUESTION_SUCCEEDED,
  SEEK_ANSWER_FOR_QUESTION_FAILED,
  FETCHING_SEEKQA_SESSIONS,
  FETCHING_SEEKQA_SESSIONS_SUCCEEDED,
  FETCHING_SEEKQA_SESSIONS_FAILED,
  FETCHING_SEEKQA_CHATS,
  FETCHING_SEEKQA_CHATS_SUCCEEDED,
  FETCHING_SEEKQA_CHATS_FAILED,
  INVALIDATE_SEEK_SESSION,
  DELETING_SEEKQA_SESSION_SUCCEEDED,
  DELETING_SEEKQA_SESSIONS_SUCCEEDED,
  FETCHING_SEEKQA_SUGGESTIONS,
  FETCHING_SEEKQA_SUGGESTIONS_SUCCEEDED,
  FETCHING_SEEKQA_SUGGESTIONS_FAILED,
  UPDATING_SEEK_HELPFUL,
  UPDATING_SEEK_HELPFUL_SUCCEEDED,
  FETCHING_EMAIL_FOR_SEEK_RESPONSE,
  FETCHING_EMAIL_FOR_SEEK_RESPONSE_SUCCEEDED,
  FETCHING_EMAIL_FOR_SEEK_RESPONSE_FAILED,
  FETCHING_SEEK_LIMIT_FAILED,
  FETCHING_SEEK_LIMIT_SUCCEEDED,
  FETCHING_SEEK_QUESTION_COUNT,
  FETCHING_SEEK_QUESTION_COUNT_SUCCEEDED,
  FETCHING_SEEK_QUESTION_COUNT_FAILED,
  SEARCHING_MSDYNAMICS_OPPORTUNITY_RECOMMENDED_ASSETS_REQUEST,
  SEARCHING_MSDYNAMICS_OPPORTUNITY_RECOMMENDED_ASSETS_SUCCEEDED,
  SEARCHING_MSDYNAMICS_OPPORTUNITY_RECOMMENDED_ASSETS_FAILED,
  UPDATING_FOLIO_SUCCEDDED,
  DELETING_FOLIO_SUCCEDDED,
} from "../actions/actionTypes.jsx";

import { combineReducers } from "redux";
import _ from "lodash";

const initialState = {
  query: "",
  searching: false,
  invalidated: true,
  items: [],
  currentPage: -1,
  totalPages: 0,
  loadMore: true,
  assets: {
    query: "",
    searching: false,
    currentPage: -1,
    totalPages: 0,
    totalRecordsCount: 0,
    recordsPerPage: 12,
    loadMore: true,
    items: [],
    invalidated: true,
  },
  collections: {
    query: "",
    searching: false,
    currentPage: -1,
    totalPages: 0,
    totalRecordsCount: 0,
    recordsPerPage: 12,
    loadMore: true,
    items: [],
    invalidated: true,
  },
  streams: {
    query: "",
    searching: false,
    currentPage: -1,
    totalPages: 0,
    totalRecordsCount: 0,
    recordsPerPage: 12,
    loadMore: true,
    items: [],
    invalidated: true,
  },
  groups: {
    query: "",
    searching: false,
    currentPage: -1,
    totalPages: 0,
    totalRecordsCount: 0,
    recordsPerPage: 12,
    loadMore: true,
    items: [],
    invalidated: true,
  },
  contacts: {
    query: "",
    searching: false,
    currentPage: -1,
    totalPages: 0,
    totalRecordsCount: 0,
    recordsPerPage: 12,
    loadMore: true,
    items: [],
    invalidated: true,
  },
  contactLists: {
    query: "",
    searching: false,
    currentPage: -1,
    totalPages: 0,
    totalRecordsCount: 0,
    recordsPerPage: 12,
    loadMore: true,
    items: [],
    invalidated: true,
  },
  tags: {
    loading: false,
    invalidated: true,
    item: null,
    totalItems: 0,
  },
  assetDetails: {
    loading: false,
    invalidated: true,
    item: null,
  },
  userGroupSelection: {
    query: "",
    searching: false,
    currentPage: -1,
    totalPages: 0,
    loadMore: true,
    items: [],
    invalidated: true,
  },
  users: {
    query: "",
    searching: false,
    currentPage: -1,
    totalPages: 0,
    totalRecordsCount: 0,
    recordsPerPage: 12,
    loadMore: true,
    items: [],
    invalidated: true,
  },
  opportunityRecommendedContents: {
    searching: false,
    highlights: [],
    assets: [],
  },
  opportunityRecommendedStreamContents:{
    searching: false,
    streams: [],
    error: null
  },
  opportunitySharedContents: {
    searching: false,
    highlights: [],
    assets: [],
  },
  seek: {
    loading: false,
    success: false,
    error: null,
    suggestions: {
      items: [],
      loading: false,
      success: false,
      error: null,
    },
    sessions: {
      items: [],
      loading: false,
      loadMore: false,
      error: null,
      pagination: {
        currentPage: -1,
        totalPages: 0,
        recordsPerPage: 0,
        totalRecordsCount: 0,
      },
    },
    session: {
      loading: false,
      item: null,
      error: null
    },
    chats: {
      id: "",
      items: [],
      loading: false,
      loadMore: false,
      error: null,
      emailBody: "",
      pagination: {
        currentPage: -1,
        totalPages: 0,
        recordsPerPage: 0,
        totalRecordsCount: 0,
      },
    },
    error:{},
    userLimit : 0,
    accountLimit: 0
  },
};

const initialSeekSession = {
  loading: false,
  item: null,
  error: null,
  pagination: {
    currentPage: -1,
    totalPages: 0,
    recordsPerPage: 0,
    totalRecordsCount: 0,
  }
}

function updateCollectionInArray(collections, collection) {
  if (!collection) {
    return collections;
  }

  var items = collections.map((folio, index) => {
    if (folio.id != collection.id) {
      return folio;
    }
    return {
      ...collection
    };
  })

  return items;
}

function searchReducer(state = initialState, action) {
  switch (action.type) {
    case SEARCHING_ASSET:
      var query = action.payload.query;

      return Object.assign({}, state, {
        ...state,
        assets: {
          ...state.assets,
          query: query,
          searching: true,
        },
      });
    case SEARCHING_ASSET_SUCCEDDED:
      var query = action.payload.query;
      //Check if the result is for the same query
      if (state.assets.query != query) {
        return state;
      }

      var result = action.payload.result;

      var loadMore = result.currentPage <= result.totalPages;
      var records = result.records || [];
      var items = [];
      if (result.currentPage === 0) {
        items = records;
      }
      else {
        items = [...state.assets.items, ...records];
      }

      items = _.uniqBy(items, 'id');


      return Object.assign({}, state, {
        ...state,
        assets: {
          ...state.assets,
          query: query,
          searching: false,
          items: items,
          invalidated: false,
          currentPage: result.currentPage,
          totalPages: result.totalPages,
          totalRecordsCount: result.totalRecordsCount,
          recordsPerPage: result.recordsPerPage,
          loadMore: loadMore,
        },
      });
    case SEARCHING_ASSET_FAILED:
      var query = action.payload.query;
      if (state.assets.query != query) {
        return state;
      }

      return Object.assign({}, state, {
        ...state,
        assets: {
          ...state.assets,
          query: query,
          searching: false,
          items: [],
          invalidated: false,
          currentPage: -1,
          totalPages: 0,
          totalRecordsCount: 0,
          recordsPerPage: 12,
          loadMore: true,
        },
      });

    case INVALIDATE_ASSET_SEARCH_RESULT:
      return Object.assign({}, state, {
        ...state,
        assets: {
          ...state.assets,
          query: query,
          searching: false,
          items: [],
          invalidated: true,
          currentPage: -1,
          totalPages: 0,
          totalRecordsCount: 0,
          recordsPerPage: 12,
          loadMore: true,
        },
      });

    case SEARCHING_COLLECTION:
      var query = action.payload.query;

      return Object.assign({}, state, {
        ...state,
        collections: {
          ...state.collections,
          query: query,
          searching: true,
        },
      });

    case SEARCHING_COLLECTION_SUCCEDDED:
      var query = action.payload.query;
      //Check if the result is for the same query
      if (state.collections.query != query) {
        return state;
      }

      var result = action.payload.result;

      var loadMore = result.currentPage <= result.totalPages;
      var records = result.records || [];
      var items = [];
      if (result.currentPage === 0) {
        items = records;
      }
      else {
        items = [...state.collections.items, ...records];
      }

      items = _.uniqBy(items, 'id');

      return Object.assign({}, state, {
        ...state,
        collections: {
          ...state.collections,
          query: query,
          searching: false,
          items: items,
          invalidated: false,
          currentPage: result.currentPage,
          totalPages: result.totalPages,
          totalRecordsCount: result.totalRecordsCount,
          recordsPerPage: result.recordsPerPage,
          loadMore: loadMore,
        },
      });

    case SEARCHING_COLLECTION_FAILED:
      var query = action.payload.query;
      if (state.collections.query != query) {
        return state;
      }
      return Object.assign({}, state, {
        ...state,
        collections: {
          ...state.collections,
          query: query,
          searching: false,
          items: items,
          invalidated: false,
          currentPage: -1,
          totalPages: 0,
          totalRecordsCount: 0,
          recordsPerPage: 12,
          loadMore: true,
        },
      });

    case INVALIDATE_COLLECTION_SEARCH_RESULT:
      return Object.assign({}, state, {
        ...state,
        collections: {
          ...state.collections,
          query: query,
          searching: false,
          items: [],
          invalidated: true,
          currentPage: -1,
          totalPages: 0,
          totalRecordsCount: 0,
          recordsPerPage: 12,
          loadMore: true,
        },
      });

    case SEARCHING_STREAM:
      var query = action.payload.query;

      return Object.assign({}, state, {
        ...state,
        streams: {
          ...state.streams,
          query: query,
          searching: true,
        },
      });

    case SEARCHING_STREAM_SUCCEDDED:
      var query = action.payload.query;
      //Check if the result is for the same query
      if (state.streams.query != query) {
        return state;
      }

      var result = action.payload.result;

      var loadMore = result.currentPage <= result.totalPages;
      var records = result.records || [];

      var items = [];
      if (result.currentPage === 0) {
        items = records;
      }
      else {
        items = [...state.streams.items, ...records];
      }

      items = _.uniqBy(items, 'id');

      return Object.assign({}, state, {
        ...state,
        streams: {
          ...state.streams,
          query: query,
          searching: false,
          items: items,
          invalidated: false,
          currentPage: result.currentPage,
          totalPages: result.totalPages,
          totalRecordsCount: result.totalRecordsCount,
          recordsPerPage: result.recordsPerPage,
          loadMore: loadMore,
        },
      });
    case SEARCHING_STREAM_FAILED:
      var query = action.payload.query;
      if (state.streams.query != query) {
        return state;
      }
      return Object.assign({}, state, {
        ...state,
        streams: {
          ...state.streams,
          query: query,
          searching: false,
          items: items,
          invalidated: false,
          currentPage: -1,
          totalPages: 0,
          totalRecordsCount: 0,
          recordsPerPage: 12,
          loadMore: true,
        },
      });

    case INVALIDATE_STREAM_SEARCH_RESULT:
      return Object.assign({}, state, {
        ...state,
        streams: {
          ...state.streams,
          query: query,
          searching: false,
          items: [],
          invalidated: true,
          currentPage: -1,
          totalPages: 0,
          totalRecordsCount: 0,
          recordsPerPage: 12,
          loadMore: true,
        },
      });

    case SEARCHING_GROUP:
      var query = action.payload.query;

      return Object.assign({}, state, {
        ...state,
        groups: {
          ...state.groups,
          query: query,
          searching: true,
        },
      });

    case SEARCHING_GROUP_SUCCEDDED:
      var query = action.payload.query;
      //Check if the result is for the same query
      if (state.groups.query != query) {
        return state;
      }

      var result = action.payload.result;

      var loadMore = result.currentPage <= result.totalPages;
      var records = result.records || [];
      
      var items = [];
      if (result.currentPage === 0) {
        items = records;
      }
      else {
        items = [...state.groups.items, ...records];
      }

      items = _.uniqBy(items, 'id');

      return Object.assign({}, state, {
        ...state,
        groups: {
          ...state.groups,
          query: query,
          searching: false,
          items: items,
          invalidated: false,
          currentPage: result.currentPage,
          totalPages: result.totalPages,
          totalRecordsCount: result.totalRecordsCount,
          recordsPerPage: result.recordsPerPage,
          loadMore: loadMore,
        },
      });
    case SEARCHING_GROUP_FAILED:
      var query = action.payload.query;
      if (state.groups.query != query) {
        return state;
      }
      return Object.assign({}, state, {
        ...state,
        groups: {
          ...state.groups,
          query: query,
          searching: false,
          items: items,
          invalidated: false,
          currentPage: -1,
          totalPages: 0,
          totalRecordsCount: 0,
          recordsPerPage: 12,
          loadMore: true,
        },
      });

    case INVALIDATE_GROUP_SEARCH_RESULT:
      return Object.assign({}, state, {
        ...state,
        groups: {
          ...state.groups,
          query: query,
          searching: false,
          items: [],
          invalidated: true,
          currentPage: -1,
          totalPages: 0,
          totalRecordsCount: 0,
          recordsPerPage: 12,
          loadMore: true,
        },
      });

    case SEARCHING_CONTACT:
      var query = action.payload.query;

      return Object.assign({}, state, {
        ...state,
        contacts: {
          ...state.contacts,
          query: query,
          searching: true,
        },
      });

    case SEARCHING_CONTACT_SUCCEDDED:
      var query = action.payload.query;
      //Check if the result is for the same query
      if (state.contacts.query != query) {
        return state;
      }

      var result = action.payload.result;

      var loadMore = result.currentPage <= result.totalPages;
      var records = result.records || [];
      var items = [];

      if (result.currentPage === 0) {
        items = records;
      }
      else {
        items = [...state.contacts.items, ...records];
      }

      items = _.uniqBy(items, 'id');

      return Object.assign({}, state, {
        ...state,
        contacts: {
          ...state.contacts,
          query: query,
          searching: false,
          items: items,
          invalidated: false,
          currentPage: result.currentPage,
          totalPages: result.totalPages,
          totalRecordsCount: result.totalRecordsCount,
          recordsPerPage: result.recordsPerPage,
          loadMore: loadMore,
        },
      });

    case SEARCHING_CONTACT_FAILED:
      var query = action.payload.query;
      if (state.contacts.query != query) {
        return state;
      }
      return Object.assign({}, state, {
        ...state,
        contacts: {
          ...state.contacts,
          query: query,
          searching: false,
          items: items,
          invalidated: false,
          currentPage: -1,
          totalPages: 0,
          totalRecordsCount: 0,
          recordsPerPage: 12,
          loadMore: true,
        },
      });

    case INVALIDATE_CONTACT_SEARCH_RESULT:
      return Object.assign({}, state, {
        ...state,
        contacts: {
          ...state.contacts,
          query: query,
          searching: false,
          items: [],
          invalidated: true,
          currentPage: -1,
          totalPages: 0,
          totalRecordsCount: 0,
          recordsPerPage: 12,
          loadMore: true,
        },
      });

    case SEARCHING_CONTACT_LIST:
      var query = action.payload.query;

      return Object.assign({}, state, {
        ...state,
        contactLists: {
          ...state.contactLists,
          query: query,
          searching: true,
        },
      });

    case SEARCHING_CONTACT_LIST_SUCCEDDED:
      var query = action.payload.query;
      //Check if the result is for the same query
      if (state.contactLists.query != query) {
        return state;
      }

      var result = action.payload.result;

      var loadMore = result.currentPage <= result.totalPages;
      var records = result.records || [];
      var items = [];

      if (result.currentPage != 0) {
        items = [...state.contactLists.items, ...records];
      } else {
        items = records;
      }

      items = _.uniqBy(items, 'id');

      return Object.assign({}, state, {
        ...state,
        contactLists: {
          ...state.contactLists,
          query: query,
          searching: false,
          items: items,
          invalidated: false,
          currentPage: result.currentPage,
          totalPages: result.totalPages,
          totalRecordsCount: result.totalRecordsCount,
          recordsPerPage: result.recordsPerPage,
          loadMore: loadMore,
        },
      });

    case SEARCHING_CONTACT_LIST_FAILED:
      var query = action.payload.query;
      if (state.contactLists.query != query) {
        return state;
      }
      return Object.assign({}, state, {
        ...state,
        contactLists: {
          ...state.contactLists,
          query: query,
          searching: false,
          items: items,
          invalidated: false,
          currentPage: -1,
          totalPages: 0,
          totalRecordsCount: 0,
          recordsPerPage: 12,
          loadMore: true,
        },
      });

    case INVALIDATE_CONTACT_LIST:
      return Object.assign({}, state, {
        ...state,
        contactLists: {
          ...state.contactLists,
          query: query,
          searching: false,
          items: [],
          invalidated: true,
          currentPage: -1,
          totalPages: 0,
          totalRecordsCount: 0,
          recordsPerPage: 12,
          loadMore: true,
        },
      });

    case SEARCHING_CONTACT_FOR_AUTOCOMPLETE:
      var query = action.payload;

      var items = state.contacts.items;
      if (!query) {
        items = [];
      }
      return Object.assign({}, state, {
        ...state,
        contacts: {
          ...state.contacts,
          query: action.payload,
          searching: true,
          items: items,
        },
      });

    case SEARCHING_CONTACT_FOR_AUTOCOMPLETE_SUCCEDDED:
      var query = action.payload.query;

      if (state.contacts.query !== query) {
        return state;
      }

      let contactItems = action.payload.result.records;

      return Object.assign({}, state, {
        ...state,
        contacts: {
          ...state.contacts,
          query: action.payload.query,
          searching: false,
          items: contactItems,
        },
      });

    case SEARCHING_CONTACT_FOR_AUTOCOMPLETE_FAILED:
      return Object.assign({}, state, {
        ...state,
        contacts: {
          ...state.contacts,
          query: action.payload,
          searching: false,
          items: [],
          error: action.payload.error,
        },
      });

    case INVALIDATE_AUTOCOMPLETE_CONTACT:
      return Object.assign({}, state, {
        ...state,
        contacts: {
          ...state.contacts,
          searching: false,
          items: [],
          error: null,
        },
      });

    case FETCHING_TAGS:
      return Object.assign({}, state, {
        ...state,
        tags: {
          ...state.tags,
          loading: true,
          invalidated: true,
        },
      });

    case FETCHING_TAGS_SUCCEDDED:
      var tagKeys = Object.keys(action.payload.tag);

      var tags = tagKeys
        .map((result) => {
          return {
            key: result,
            count: action.payload.tag[result],
          };
        })
        .sort((t1, t2) => t2.count - t1.count);

      return Object.assign({}, state, {
        ...state,
        tags: {
          ...state.tags,
          loading: false,
          invalidated: false,
          item: tags,
          totalItems: action.payload.total,
        },
      });

    case FETCHING_TAGS_FAILED:
      return Object.assign({}, state, {
        ...state,
        tags: {
          ...state.tags,
          loading: false,
          invalidated: false,
          item: null,
        },
      });

    case INVALIDATE_TAGS:
      return Object.assign({}, state, {
        ...state,
        tags: {
          ...state.tags,
          loading: false,
          invalidated: true,
          item: null,
        },
      });

    case SEARCHING_ASSET_DETAIL:
      return Object.assign({}, state, {
        ...state,
        assetDetails: {
          ...state.assetDetails,
          loading: true,
          invalidated: true,
        },
      });

    case SEARCHING_ASSET_DETAIL_SUCCEDDED:
      return Object.assign({}, state, {
        ...state,
        assetDetails: {
          ...state.assetDetails,
          loading: false,
          invalidated: false,
          item: action.payload,
        },
      });

    case SEARCHING_ASSET_DETAIL_FAILED:
      return Object.assign({}, state, {
        ...state,
        assetDetails: {
          ...state.assetDetails,
          loading: false,
          invalidated: false,
          item: null,
        },
      });

    case INVALIDATE_ASSET_DETAIL_SEARCH_RESULT:
      return Object.assign({}, state, {
        ...state,
        assetDetails: {
          ...state.assetDetails,
          loading: false,
          invalidated: true,
          item: null,
        },
      });

    case SEARCHING_USER_GROUPS_REQUEST:
      return Object.assign({}, state, {
        ...state,
        userGroupSelection: {
          ...state.userGroupSelection,
          query: action.payload,
          searching: true,
          items: items,
        },
      });

    case SEARCHING_USER_GROUPS_SUCCEDDED:
      var groupItems = [];

      if (action.payload.currentPage != 0) {
        groupItems = [...state.items, ...action.payload.records];
      } else {
        groupItems = action.payload.records;
      }

      groupItems = _.uniqBy(groupItems, "id");

      return Object.assign({}, state, {
        ...state,
        userGroupSelection: {
          ...state.userGroupSelection,
          query: action.payload.query,
          searching: false,
          items: groupItems,
        },
      });

    case SEARCHING_USER_GROUPS_FAILED:
      return Object.assign({}, state, {
        ...state,
        userGroupSelection: {
          ...state.userGroupSelection,
          query: action.payload,
          searching: false,
          items: [],
          error: action.payload.error,
        },
      });

    case INVALIDATE_AUTOCOMPLETE_USER_GROUP:
      return Object.assign({}, state, {
        ...state,
        userGroupSelection: {
          ...state.userGroupSelection,
          query: "",
          searching: false,
          items: [],
          error: null,
        },
      });

    case SEARCHING_USERS_REQUEST:
      var query = action.payload.query;

      return Object.assign({}, state, {
        ...state,
        users: {
          ...state.users,
          query: query,
          searching: true,
        },
      });

    case SEARCHING_USERS_SUCCEDDED:
      var query = action.payload.query;
      //Check if the result is for the same query
      if (state.users.query != query) {
        return state;
      }

      var result = action.payload.result;

      var loadMore = result.currentPage <= result.totalPages;
      var records = result.records || [];
      var items = [...state.users.items, ...records];

      items = _.uniqBy(items, "id");

      return Object.assign({}, state, {
        ...state,
        users: {
          ...state.users,
          query: query,
          searching: false,
          items: items,
          invalidated: false,
          currentPage: result.currentPage,
          totalPages: result.totalPages,
          totalRecordsCount: result.totalRecordsCount,
          recordsPerPage: result.recordsPerPage,
          loadMore: loadMore,
        },
      });

    case SEARCHING_USERS_FAILED:
      var query = action.payload.query;
      if (state.users.query != query) {
        return state;
      }

      return Object.assign({}, state, {
        ...state,
        users: {
          ...state.users,
          query: query,
          searching: false,
          items: items,
          invalidated: false,
          currentPage: -1,
          totalPages: 0,
          totalRecordsCount: 0,
          recordsPerPage: 12,
          loadMore: true,
        },
      });
    case SEARCHING_OPPORTUNITY_RECOMMENDED_ASSETS_REQUEST:
      return Object.assign({}, state, {
        ...state,
        opportunityRecommendedContents: {
          ...state.opportunityRecommendedContents,
          searching: true,
        },
      });
    case SEARCHING_OPPORTUNITY_RECOMMENDED_ASSETS_SUCCEEDED:
      var result = action.payload.data;

      return Object.assign({}, state, {
        ...state,
        opportunityRecommendedContents: {
          ...state.opportunityRecommendedContents,
          searching: false,
          highlights: result.highlights,
          assets: result.assets,
        },
      });
    case SEARCHING_OPPORTUNITY_RECOMMENDED_ASSETS_FAILED:
      return Object.assign({}, state, {
        ...state,
        opportunityRecommendedContents: {
          searching: false,
          highlights: [],
          assets: [],
        },
      });

    case SEARCHING_MSDYNAMICS_OPPORTUNITY_RECOMMENDED_ASSETS_REQUEST:
      console.log("SEARCHING_MSDYNAMICS_OPPORTUNITY_RECOMMENDED_ASSETS_REQUEST")
      return Object.assign({}, state, {
        ...state,
        opportunityRecommendedContents: {
          ...state.opportunityRecommendedContents,
          searching: true,
        },
      });

    case SEARCHING_MSDYNAMICS_OPPORTUNITY_RECOMMENDED_ASSETS_SUCCEEDED:
      var result = action.payload.data;
  
      return Object.assign({}, state, {
        ...state,
        opportunityRecommendedContents: {
          ...state.opportunityRecommendedContents,
          searching: false,
          highlights: result.highlights,
          assets: result.assets,
        },
      });

    case SEARCHING_MSDYNAMICS_OPPORTUNITY_RECOMMENDED_ASSETS_FAILED:
      return Object.assign({}, state, {
        ...state,
        opportunityRecommendedContents: {
          searching: false,
          highlights: [],
          assets: [],
        },
      });

    case SEARCHING_OPPORTUNITY_RECOMMENDED_STREAMS_REQUEST:
      return Object.assign({}, state, {
        ...state,
        opportunityRecommendedStreamContents: {
          ...state.opportunityRecommendedStreamContents,
          searching: true,
          streams: []
        }      
      });

    case SEARCHING_OPPORTUNITY_RECOMMENDED_STREAMS_SUCCEEDED:
      var result = action.payload.data;
      return Object.assign({}, state, {
        ...state,
        opportunityRecommendedStreamContents: {
          ...state.opportunityRecommendedStreamContents,
          searching: false,
          streams: result
        },
      }); 

      case SEARCHING_OPPORTUNITY_RECOMMENDED_STREAMS_FAILED: 
      return Object.assign({}, state, {
        ...state,
        opportunityRecommendedStreamContents: {
          ...state.opportunityRecommendedStreamContents,
          searching: false,
          error: action.payload.error
        },
      });

    case SEARCHING_OPPORTUNITY_SHARED_ASSETS_REQUEST:
      return Object.assign({}, state, {
        ...state,
        opportunitySharedContents: {
          ...state.opportunitySharedContents,
          searching: true,
        },
      });
    case SEARCHING_OPPORTUNITY_SHARED_ASSETS_SUCCEEDED:
      var result = action.payload.data;

      return Object.assign({}, state, {
        ...state,
        opportunitySharedContents: {
          searching: false,
          highlights: result.highlights,
          assets: result.assets,
        },
      });
    case SEARCHING_OPPORTUNITY_SHARED_ASSETS_FAILED:
      return Object.assign({}, state, {
        ...state,
        opportunitySharedContents: {
          searching: false,
          highlights: [],
          assets: [],
        },
      });

    case SEEK_ANSWER_FOR_QUESTION_REQUEST: {
      const { id, question } = action.payload;

      var currentSession = state.seek.session || initialSeekSession;
      if(id != null && _.get(currentSession,"item.id") != id){
        return state;
      }else if(id == null){
        currentSession = {
          ...initialSeekSession,
          creating: true,
          item: {
            id: null,
            chats: []
          }
        }
      }

      let chats = [...currentSession.item.chats, {
        question: question,
        querying: true
      }];
      
      return Object.assign({}, state, {
        ...state,
        seek: {
          ...state.seek,
          session: {
            ...currentSession,
            item: {
              ...currentSession.item,
              chats: chats
            }
          }
        }
      });
    }

    case SEEK_ANSWER_FOR_QUESTION_SUCCEEDED: {
      const { id, response } = action.payload;
      
      var currentSession = state.seek.session || initialSeekSession;
      if(id != null && currentSession.item.id != id){
        return state;
      }else if(id == null){
        currentSession = {
          ...initialSeekSession,
          creating: true,
          item: {
            id: response.session,
            chats: []
          }
        }
      }

      var chats = [...currentSession.item.chats].filter(chat => {
        return !chat.querying;
      });

      chats = [...chats, response];
      
      return Object.assign({}, state, {
        ...state,
        seek: {
          ...state.seek,
          session: {
            ...currentSession,
            item: {
              ...currentSession.item,
              chats: chats
            }
          }
        },
      });
    }
      
    case SEEK_ANSWER_FOR_QUESTION_FAILED: {
      const {  error, question } = action.payload;
      
      var currentSession = state.seek.session || initialSeekSession;
 
      var chats = [...currentSession.item.chats].filter(chat => {
        return !chat.querying;
      });

      chats = [...chats, { question: question, error: error }];
      
      return Object.assign({}, state, {
        ...state,
        seek: {
          ...state.seek,
          session: {
            ...currentSession,
            item: {
              ...currentSession.item,
              chats: chats
            }
          },
          error
        },
      });
    }

    case INVALIDATE_SEEK_SESSION: {
      return Object.assign({}, state, {
        ...state,
        seek: {
          ...state.seek,
          session: initialSeekSession
        },
      });
    }
    case FETCHING_SEEKQA_SUGGESTIONS: {
      return Object.assign({}, state, {
        ...state,
        seek: {
          ...state.seek,
          suggestions: {
            ...state.seek.suggestions,
            loading: true,
          },
        },
      });
    }
    case FETCHING_SEEKQA_SUGGESTIONS_SUCCEEDED: {
      return Object.assign({}, state, {
        ...state,
        seek: {
          ...state.seek,
          suggestions: {
            loading: false,
            success: true,
            items: action.payload.suggestions,
            error: null,
          },
        },
      });
    }

    case FETCHING_SEEKQA_SUGGESTIONS_FAILED: {
      return Object.assign({}, state, {
        ...state,
        seek: {
          ...state.seek,
          suggestions: {
            loading: false,
            success: false,
            items: [],
            error: null,
          },
        },
      });
    }
    case FETCHING_SEEKQA_SESSIONS: {
      const { page, limit } = action.payload;

      return Object.assign({}, state, {
        ...state,
        seek: {
          ...state.seek,
          sessions: {
            ...state.seek.sessions,
            loading: true,
          },
        },
      });
    }

    case FETCHING_SEEKQA_SESSIONS_SUCCEEDED: {
      var records = action.payload.records || [];
      var loadMore = action.payload.currentPage <= action.payload.totalPages;

      var items = [...state.seek.sessions.items, ...records];
      if (action.payload.currentPage !== 0) {
        items = [...state.seek.sessions.items, ...records];
      } else {
        items = [...records];
      }

      return Object.assign({}, state, {
        ...state,
        seek: {
          ...state.seek,
          sessions: {
            loading: false,
            items: items,
            loadMore: loadMore,
            pagination: {
              currentPage: action.payload.currentPage,
              recordsPerPage: action.payload.recordsPerPage,
              totalPages: action.payload.totalPages,
              totalRecordsCount: action.payload.totalRecordsCount,
            },
          },
        },
      });
    }

    case FETCHING_SEEKQA_SESSIONS_FAILED: {
      return Object.assign({}, state, {
        ...state,
        sessions: {
          items: [],
          loading: false,
          loadMore: false,
          pagination: {
            currentPage: -1,
            recordsPerPage: 0,
            totalPages: 0,
            totalRecordsCount: 0,
          },
        },
      });
    }

    case FETCHING_SEEKQA_CHATS: {
      const { session, page, limit } = action.payload;

      return Object.assign({}, state, {
        ...state,
        seek: {
          ...state.seek,
          session: {
            ...initialSeekSession,
            loading: true,
            item: {
              ...initialSeekSession.item,
              ...session
            }
          }
        },
      });
    }

    case FETCHING_SEEKQA_CHATS_SUCCEEDED: {
      const {session, response} = action.payload;
      const {records, currentPage, recordsPerPage, totalPages, totalRecordsCount} = response;

      const currentSession = state.seek.session || initialSeekSession;
      if(currentSession.item.id != session.id){
        return state;
      }

      var currentRecords = currentSession.item.chats || [];
      currentRecords = [...currentRecords, ...records];
      currentRecords = _.uniqBy(currentRecords, "id");

      return Object.assign({}, state, {
        ...state,
        seek: {
          ...state.seek,
          session: {
            ...state.seek.session,
            loading: false,
            item: {
              ...state.seek.session.item,
              chats: currentRecords
            },
            pagination: {
              currentPage: currentPage,
              recordsPerPage: recordsPerPage,
              totalPages: totalPages,
              totalRecordsCount: totalRecordsCount,
            },
          },
        },
      });
    }

    case FETCHING_SEEKQA_CHATS_FAILED: {
      const {session, error} = action.payload;

      const currentSession = state.seek.session || initialSeekSession;
      if(currentSession.item.id != session.id){
        return state;
      }

      return Object.assign({}, state, {
        ...state,
        seek: {
          ...state.seek,
          session: {
            ...currentSession,
            loading: false,
            error: error,
          }
        },
      });
    }

    case DELETING_SEEKQA_SESSION_SUCCEEDED: {
      var id = action.payload.id;
      var items = [...state.seek.sessions.items].filter(
        (item) => item.id != id
      );

      return Object.assign({}, state, {
        ...state,
        seek: {
          ...state.seek,
          sessions: {
            ...state.seek.sessions,
            items: items,
          },
        },
      });
    }

    case DELETING_SEEKQA_SESSIONS_SUCCEEDED: {
      return Object.assign({}, state, {
        ...state,
        seek: {
          ...state.seek,
          sessions: {
            ...state.seek.sessions,
            items: [],
          },
        },
      });
    }

    case UPDATING_SEEK_HELPFUL: {
      const { id } = action.payload;

      var currentSession = state.seek.session || initialSeekSession;
      var chats = _.get(currentSession, 'item.chats');

      if(_.size(chats) == 0){
        return state;
      }

      chats = chats.map(chat => {
        if(chat.id === id){
          return {
            ...chat,
            updating: true
          }
        }

        return chat;
      })
      
      return Object.assign({}, state, {
        ...state,
        seek: {
          ...state.seek,
          session: {
            ...currentSession,
            item: {
              ...currentSession.item,
              chats: chats
            }
          }
        }
      });
    }

    case UPDATING_SEEK_HELPFUL_SUCCEEDED: {
      const { id, response } = action.payload;

      var currentSession = state.seek.session || initialSeekSession;
      var chats = _.get(currentSession, 'item.chats');

      if(_.size(chats) == 0){
        return state;
      }

      chats = chats.map(chat => {
        if(chat.id === id){
          return {
            ...chat,
            updating: false,
            isHelpful: response.isHelpful
          }
        }

        return chat;
      })
      
      return Object.assign({}, state, {
        ...state,
        seek: {
          ...state.seek,
          session: {
            ...currentSession,
            item: {
              ...currentSession.item,
              chats: chats
            }
          }
        }
      });
    }

    case FETCHING_EMAIL_FOR_SEEK_RESPONSE: {
      return Object.assign({}, state, {
        ...state,
          seek:{
            ...state.seek,
            chats:{
              ...state.seek.chats,
              loading: true,
            }
          }
      })
    }

    case FETCHING_EMAIL_FOR_SEEK_RESPONSE_SUCCEEDED: {
      var emailBody = action.payload.body;

      return Object.assign({}, state, {
        ...state,
          seek:{
            ...state.seek,
            chats:{
              ...state.seek.chats,
              loading: false,
              emailBody: emailBody
            }
          }
      })
    }

    case FETCHING_EMAIL_FOR_SEEK_RESPONSE_FAILED: {

      return Object.assign({}, state, {
        ...state,
          seek:{
            ...state.seek,
            chats:{
              ...state.seek.chats,
              loading: false,
              error: action.payload.error
            }
          }
      })
    }
      
    case FETCHING_SEEK_LIMIT_FAILED:

      return Object.assign({}, state, {
        ...state,
        seek: {
          ...state.seek,
          error : action.payload
        }
      })
    


    case FETCHING_SEEK_QUESTION_COUNT: {
      return Object.assign({}, state, {
        ...state,
        seek: {
          ...state.seek,
          loading: true
        }
      })
    }

    case FETCHING_SEEK_QUESTION_COUNT_SUCCEEDED: {
      const accountLimit = action.payload.accountLimit;
      const userLimit = action.payload.userLimit;

      return Object.assign({}, state, {
        ...state,
        seek: {
          ...state.seek,
          loading: false,
          userLimit : userLimit,
          accountLimit: accountLimit,
        }
      })
    }

    case FETCHING_SEEK_QUESTION_COUNT_FAILED:
    const error = action.payload.error;

    return Object.assign({}, state, {
      ...state,
      seek: {
        ...state.seek,
        loading: false,
        error: error
      }
    })

    case UPDATING_FOLIO_SUCCEDDED:
      var id = action.payload.id;

      var items = updateCollectionInArray(state.collections.items, action.payload.folio);

      return Object.assign({}, state, {
        ...state,
        collections: {
          ...state.collections,
          items: items
        },
      });

    case DELETING_FOLIO_SUCCEDDED:
      var id = action.payload;

      var items = (state.collections.items || []).filter(item => {
        return item.id != id;
      });


      return Object.assign({}, state, {
        ...state,
        collections: {
          ...state.collections,
          items: items
        },
      });


    default:
      return state;
  }
}

export { searchReducer };
